import { render } from 'preact/compat';
import Widget from './components/Widget';
import Highlight from './lib/Highlight';
import { RoughAnnotation } from 'rough-notation/lib/model';
import { selectStrategies } from './lib/util';
import { HEY_GENIUS_FIELD, HOST_CLASSNAME } from './constants';
import { ManagedAnalyticsProvider } from '@libertify.frontend/analytics';

function loadPublicSettings() {
  // from window variables or from div attribute (for Chrome extension)
  const settingsElement = document.querySelector('[data-hg-settings]');

  if (settingsElement) {
    const settingsAttribute = settingsElement.getAttribute('data-hg-settings');
    if (settingsAttribute) {
      try {
        const settings = JSON.parse(settingsAttribute);
        window[HEY_GENIUS_FIELD] = settings;
      } catch (e) {
        console.debug('Error parsing widget settings from HTML attribute:', e);
      }
    }
  }
}
if (!document.querySelector(`.${HOST_CLASSNAME}`)) {
  const host = document.createElement('div');
  host.classList.add(HOST_CLASSNAME);
  host.style.position = 'fixed';
  host.style.zIndex = '100000';
  host.style.pointerEvents = 'none';
  document.body.append(host);
  const shadow = host.attachShadow({ mode: 'open' });

  loadPublicSettings();
  const { processingStrategy, dataRetrievalStrategy } = selectStrategies();
  window['HeyGenius'] = window['HeyGenius'] ?? { highlights: {} };
  window['HeyGenius'].highlights = window['HeyGenius'].highlights ?? {};
  window['HeyGenius'].highlights.version = import.meta.env['VITE_APP_VERSION'];
  const isPreview = !!(window[HEY_GENIUS_FIELD] as any)?.liveData;

  render(
    <ManagedAnalyticsProvider
      appName="heygenius_widget_highlight"
      domains={['.heygenius.ai']}
      environment={import.meta.env['VITE_ENV_NAME']}
      segmentWriteKey={import.meta.env['VITE_SEGMENT_WRITE_KEY']}
      // disable all tracking in preview mode
      enabled={!isPreview}
    >
      <Widget<{
        highlights?: Highlight[];
        annotations?: { [key: string]: RoughAnnotation[] };
      }>
        dataRetrievalStrategy={dataRetrievalStrategy}
        processingStrategy={processingStrategy}
      />
    </ManagedAnalyticsProvider>,
    shadow,
  );
}
